import { useAlertUiTranslation } from '../../../../../../ui/hooks';
import Attachment from '@mui/icons-material/Attachment';
import { IconButton } from '@mui/material';
import React from 'react';
const AddAttachmentButton = ({ onSaveAttachments, loadingAttachmentUpload, inputFileRef, }) => {
    const { t } = useAlertUiTranslation();
    const changeHandler = (event) => {
        event.preventDefault();
        if (event.target.files) {
            if (window.File && window.FileReader && window.FileList && window.Blob) {
                if (event.target.files.length > 0) {
                    onSaveAttachments(Array.from(event.target.files));
                }
            }
            else {
                alert(t('pages.edit.richTextEditors.apiNotSupportedByBrowser'));
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { id: 'icon-button-file', "data-test": 'icon-button-file', "data-testid": 'file-uploader', type: 'file', hidden: true, onChange: changeHandler, onClick: (event) => (event.target.value = ''), multiple: true, disabled: loadingAttachmentUpload, ref: inputFileRef }),
        !inputFileRef && (React.createElement("label", { htmlFor: 'icon-button-file' },
            React.createElement(IconButton, { "data-testid": 'add-attachment-btn', component: 'span', size: 'small', color: 'inherit', disabled: loadingAttachmentUpload, "aria-label": t('pages.edit.richTextEditors.attachment') },
                React.createElement(Attachment, null))))));
};
export default AddAttachmentButton;
